module.exports = __webpack_public_path__ + "static/media/team_01.2e831ab4.jpg";